import React, { useContext } from 'react';

import { ContentMetadata } from '@candu-ai/content/types';
import { CraftMode } from 'craft/containers/Craft/Craft';

export interface CraftPropsContextType {
  mode: CraftMode;
  documentId: number;
  contentMetadata?: ContentMetadata;
}

export const CraftPropsContext = React.createContext<CraftPropsContextType>(
  {} as CraftPropsContextType,
);

export const useCraftPropsContext = (): CraftPropsContextType => useContext(CraftPropsContext);

type Props = CraftPropsContextType & {
  children: any;
};

export const CraftPropsContextProvider = ({
  documentId,
  mode,
  contentMetadata,
  children,
}: Props) => {
  return (
    <CraftPropsContext.Provider value={{ contentMetadata, documentId, mode }}>
      {children}
    </CraftPropsContext.Provider>
  );
};
